export default __webpack_public_path__ + "static/media/+.461a1cea.svg";